import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiServiceService } from '../service/api-service.service';
import { SharedService } from '../service/shared.service';
import { configuration } from 'src/configuration';

@Component({
  selector: 'app-profileview',
  templateUrl: './profileview.component.html',
  styleUrls: ['./profileview.component.css']
})
export class ProfileviewComponent implements OnInit {
  submit = false;
  showWhatsApp = false;
  profileviewForm: FormGroup;
  isSubmitted = false;

  constructor(private fb: FormBuilder, private router: Router, public apiService: ApiServiceService, public shared: SharedService) {
    this.shared.isWhiteMenu = true
    this.profileviewForm = this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
      is_whatsapp: [false],
      whatsapp_no: ['']
    });
  }

  ngOnInit(): void{
    this.getData()
  }
  async getData() {
    const res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_USER_DATA,{});
    console.log("Response:", res);
    if (res && !res.error && res.data) {
      this.profileviewForm.patchValue({
        name : res.data.name,
        email : res.data.email,
        phone : res.data.phone,
        whatsapp_no : res.data.whatsapp_no,
      })
      this.profileviewForm.get('email')?.disable();
    }
}


async onSubmit() {
  this.submit = true;
  if (this.profileviewForm.valid) {
      const userData = {
          name: this.profileviewForm.value.name,
          phone: this.profileviewForm.value.phone,
          whatsapp_no: this.profileviewForm.value.whatsapp_no
      };

      const res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.UPDATE_PROFILE, userData);
      console.log("Response:", res);
      
      if (res && !res.error) {
          this.isSubmitted = true;
          this.getData()
          // this.profileviewForm.reset();
      }
  } else {
      console.log("Form is invalid");
  }
  this.submit = false; // Reset the submit flag
}


  toggleWhatsApp() {
    const isWhatsAppControl = this.profileviewForm.get('is_whatsapp');
    const whatsappNumberControl = this.profileviewForm.get('whatsapp_number');

    if (isWhatsAppControl && whatsappNumberControl) {
      this.showWhatsApp = isWhatsAppControl.value;

      if (!this.showWhatsApp) {
        whatsappNumberControl.reset();
        whatsappNumberControl.clearValidators();
      } else {
        whatsappNumberControl.setValidators(Validators.required);
      }
      whatsappNumberControl.updateValueAndValidity();
    }

    // Update showWhatsApp based on the value of is_whatsapp
    this.showWhatsApp = isWhatsAppControl?.value || false;
  }
}
